/**
 * Circuit Culture — scroll reveal
 * Fades and slides sections into view as the user scrolls down.
 * Animates only transform + opacity; respects prefers-reduced-motion.
 */

const REVEAL = 'cc-reveal';
const VISIBLE = 'cc-reveal--visible';

function injectStyles() {
  const style = document.createElement('style');
  style.textContent = `
    .cc-reveal {
      opacity: 0;
      transform: translateY(22px);
      transition: opacity 480ms ease-out, transform 480ms ease-out;
    }
    .cc-reveal--visible {
      opacity: 1;
      transform: translateY(0);
    }
  `;
  document.head.appendChild(style);
}

function applyScrollReveal() {
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const sections = Array.from(document.querySelectorAll('#MainContent .shopify-section'));

  if (!sections.length) return;

  if (prefersReduced) {
    sections.forEach((el) => el.classList.add(VISIBLE));
    return;
  }

  injectStyles();

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        if (isIntersecting) {
          target.classList.add(VISIBLE);
          observer.unobserve(target);
        }
      });
    },
    { threshold: 0.07, rootMargin: '0px 0px -40px 0px' }
  );

  sections.forEach((el, i) => {
    if (i === 0) {
      // First section (hero / above fold) — always visible immediately
      el.classList.add(VISIBLE);
    } else {
      el.classList.add(REVEAL);
      observer.observe(el);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', applyScrollReveal);
} else {
  applyScrollReveal();
}
